<template>
    <!-- 車辨系統 -->
    <div class="pic-ana">
        <div class="mb-1" id="videoContainer">
            <video width="300" height="300" id="video" autoplay playsinline></video>
            <canvas width="300" height="300" id="canvas"></canvas>
            <div id="overlay" class="overlay"></div>
        </div>
        <div>
            <BRow>
                <BCol>
                    <BButton 
                        class="w-100 text-white"
                        variant="gradient-warning" 
                        @click="refPicAnalysis.capture()"
                    >
                        拍照
                    </BButton>
                </BCol>
                <BCol>
                    <BButton 
                        class="w-100 text-white"
                        variant="gradient-warning"
                        @click="refPicAnalysis.recognize()" 
                    >
                        文字辨識
                    </BButton>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        class="w-100 mt-2"
                        label="辨識輸出"
                        label-for="textResult"
                    >
                        <BFormInput
                            id="textResult"
                            placeholder=""
                            readonly
                        />
                    </BFormGroup>
                </BCol>
            </BRow>
        </div>
    </div>
</template>
<script>
import { onMounted, ref, watch } from '@vue/composition-api'
import utils from '@/sag-core/utils.js'
import picAnalysis from './js/PicAnalysis.js'
import { BButton, BRow, BCol, BFormInput, BFormGroup } from 'bootstrap-vue'
export default {
    name: 'PictureAnalysis',
    components: {
        BButton,
        BRow,
        BCol,
        BFormInput,
        BFormGroup
    },
    props: {
        test: {
            type: Boolean,
            default: false
        }
    },
    setup(props, ctx) {
        const refPicAnalysis = ref(null)

        picAnalysis.emit = ctx.emit

        onMounted(()=>{
            if(!props.test){
                refPicAnalysis.value = picAnalysis
            }
            else{
                refPicAnalysis.value = {
                    capture: ()=>{

                    },
                    recognize: ()=>{
                        ctx.emit('change', 'MGH-2387')
                    }
                }
            }
            picAnalysis.init()
        })

        return {
            refPicAnalysis
        }
    }
}
</script>
<style lang="scss">
.pic-ana {
    background-color: white;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    width: 100%;
    #video:focus {
        outline: 2px solid #008CBA;
    }
    #videoContainer {
        position: relative;
        width: 100%;
        height: 100%;
        // padding-bottom: 75%;
        // overflow: hidden;
    }
    #video, #canvas {
        position: relative;
        // width: 300px;
        // height: 300px;
        object-fit: contain;
        top: 0;
        left: 50%;
        transform: translate(-50%, 0);  
        // object-fit: cover;
    }
    #canvas {
        position: absolute;
        z-index: 1;
        opacity: 1;      
        touch-action: none;
    }
    .overlay {
        position: absolute;
        border: 2px dashed #008CBA;
        z-index: 2;
        display: none;
    }
}
</style>